import React from 'react';
import TreeView from '../tree/TreeView';
import useMultiSelect from './UseMultiSelect';

const MultiSelect = ({ label, name, value, error, message, options, onChange, 
    isLoading, className }) => {
  const {formattedOptions} = useMultiSelect(options)
  return (
    <TreeView 
      label={label}
      name={name}
      value={value}
      error={error}
      message={message}
      options={formattedOptions}
      selectableLeavesOnly={true}
      singleSelect={false}
      onChange={onChange}
      isLoading={isLoading}
      className={className} />);
}

export default MultiSelect;